<template>
	<ss-activity-detail />
</template>

<script>
	import ssActivityDetail from '@/components/ss-activity-detail/ss-activity-detail.vue'
	export default {
		name: 'culturalInfoDetail',
		components: {
			ssActivityDetail
		}
	}
</script>
